//
// TimePickResultDetails.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/pickResults/PickResultDetails";
import "./TimeDataTipPosition";

var TimePickResultDetails = createModule("gtl::TimePickResultDetails", ["commons::PickResultDetails"], ClosetObject, [
    ,
    ,
    ,
    {
        tipPosition: 4,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default TimePickResultDetails;
